
import { Search } from 'vant'

export default {
  name: 'home',
  components: {
    [Search.name]: Search
  },
  data () {
    return {
      // 公众号的名称
      text: 'demo',
      searchValue: ''
    }
  },
  methods: {
    // 普通提示
    initFn () {
      this.$dialog({
        message: '这是弹窗内容'
      }).then(() => {
        // on close
      })
    },
    // 确认提示
    test2 () {
      this.$dialog.confirm({
        title: '',
        message: '你确定要注销该设备吗？'
      }).then(() => {
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    // 加载提示
    onSearchFn () {
      this.$toast({
        message: '加载中...'
      })
    }
  },
  created () {
    this.initFn();
  }
}
